import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    { label: 'Web', value: 1 },
    { label: 'Mobile', value: 2 },
    { label: 'App', value: 3 },
]

export default function SelectDeviceStatic({...props}) {
    const myProps = {
        placeholder: 'All devices',
        firstSelect: true, 
        isClearable: false, 
        options: OPTIONS,
        icon: { icon: 'phone-laptop' },
        isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}